export enum FeatureFlagType {
  AllowClauseRenaming = 'ALLOW_CLAUSE_RENAMING',
  AutomationSmartClauseApi = 'AUTOMATION_SMART_CLAUSE_API',
  AutomationSmartClauseFull = 'AUTOMATION_SMART_CLAUSE_FULL',
  BulkDocumentMetadata = 'BULK_DOCUMENT_METADATA',
  BulkDocumentMetadataFileMove = 'BULK_DOCUMENT_METADATA_FILE_MOVE',
  BulkDocumentMetadataFilenameUpdate = 'BULK_DOCUMENT_METADATA_FILENAME_UPDATE',
  BulkDocumentMetadataMultipleTasks = 'BULK_DOCUMENT_METADATA_MULTIPLE_TASKS',
  DisableDocTagging = 'DISABLE_DOC_TAGGING',
  EditClause = 'EDIT_CLAUSE',
  EsWeightedSearch = 'ES_WEIGHTED_SEARCH',
  SingleSignOn = 'SSO',
  SyncPairWebhook = 'SYNC_PAIR_WEBHOOK',
  TicketInboundEmail = 'TICKET_INBOUND_EMAIL',
  Workflow = 'WORKFLOW_DEMO',
}
